<template>
  <div class="menu">
    <logo :collapse="$store.state.Config.menuCollapse" />
    <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
      background-color="transparent"
      text-color="#fff"
      active-text-color="#ddd"
      :collapse="$store.state.Config.menuCollapse"
      :collapse-transition="false"
      :router="true"
      mode="vertical"
      style="border-right: none;"
    >
      <template v-for="menu in sidebarData">
        <el-submenu style="height: 100%;"
          v-if="menu.Subset && menu.Subset.length !== 0"
          :key="menu.MenuCode"
          :index="menu.Url || menu.MenuCode"
        >
          <template slot="title">
            <svg-icon
              :icon-class="menu.MenuCode"
              style="font-size: 20px"
              :style="{marginRight:$store.state.Config.menuCollapse?'0px':'16px'}"
            ></svg-icon>
            <span style="font-size: 16px; margin-left: 4px;" class="wrap">{{
              $t("app.router." + menu.MenuName)
            }}</span>
          </template>
          <el-menu-item style="height: 100%;padding-left: 10px;"
            v-for="itemMenu in menu.Subset"
            :index="itemMenu.Url"
            :key="itemMenu.MenuCode"
          >
            <svg-icon
              :icon-class="itemMenu.MenuCode"
              style="font-size: 20px"
              :style="{marginRight:$store.state.Config.menuCollapse?'0px':'16px'}"
            ></svg-icon>
            <span style="font-size: 16px; margin-left: 4px;" class="wrap">{{
              $t("app.router." + itemMenu.MenuName)
            }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="menu.Url" :key="menu.MenuCode" style="height: 100%;">
          <svg-icon
            :icon-class="menu.MenuCode"
            style="font-size: 20px"
            :style="{marginRight:$store.state.Config.menuCollapse?'0px':'16px'}"
          ></svg-icon>
          <span style="font-size: 16px; margin-left: 4px;" class="wrap">{{
            $t("app.router." + menu.MenuName)
          }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
import Logo from "./Logo";
export default {
  name: "Menucpn",
  components: {
    Logo,
  },
  props: {
    sidebarData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    menuClick(menu) {
      if (menu.Subset && menu.Subset.length !== 0) {
        return;
      }
      this.$router.push({ path: menu.Url });
    },
  },
};
</script>
<style lang="scss" scoped>
  .wrap{
    white-space: normal;
    word-wrap: break-word;
    line-height: 30px;
    display: inline-block;
    width: 150px;
  }
/*.menu {*/
/*  !*height: 100%;*!*/
/*}*/
</style>
<style>
/*.el-menu-vertical-demo:not(.el-menu--collapse) {*/
/*  width: 100%;*/
/*  height: calc(100% - 60px);*/
/*  overflow: auto;*/
/*}*/
</style>
